import { UsePopoverDialogResponse, contextFactory } from '@frontend/design-system';
import { PersonSelectorPropsType } from '../../../../components/PersonSelector/types';
import { TransformedLegacyPerson } from '../../../../components/PersonSelector/types';
import { useManageScheduleRequestModalDetails } from '../hooks/useManageScheduleRequestModalDetails';
import { useManageScheduleRequestModalForm } from '../hooks/useManageScheduleRequestModalForm';

export type ScheduleRequestModalFormContext = {
  manageScheduleRequestModalDetails: ReturnType<typeof useManageScheduleRequestModalDetails>;
  manageScheduleRequestFormDetails: ReturnType<typeof useManageScheduleRequestModalForm>;
  personSelectorDialogProps: UsePopoverDialogResponse<HTMLButtonElement, false, HTMLDialogElement>;
  personSelectorProps: PersonSelectorPropsType;
  setTemplate: (template: string) => void;
  hasAppointmentWritebacks: boolean;
  isIntegratedOffice: boolean;
  selectedPerson: TransformedLegacyPerson | null;
  shouldSendMessageV3: boolean;
  setShouldSendMessageV3: (value: boolean) => void;
};

const ScheduleRequestModalFormContextFactory = contextFactory<ScheduleRequestModalFormContext>();

export const [ScheduleRequestModalFormContext, useScheduleRequestModalFormContext] =
  ScheduleRequestModalFormContextFactory;
